
















































import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { ImagePreview } from 'vant'
import { JointComponents } from '../../components'
import { jointGoodsModelProvider } from '../model'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: JointComponents,
  },
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      // 是否代金券
      isCoupon = computed(() => this.jointGoodsModel.value.isCoupon)

      // 当前轮播项索引
      currentBannerIndex = ref(0)

      // 轮播项改变时触发
      handleBannerChange = (index: number) => {
        this.currentBannerIndex.value = index
      }

      // 点击轮播项
      handleBannerClick = (index: number) => {
        ImagePreview({
          images: this.jointGoodsModel.value.carousePic,
          startPosition: index,
        })
      }

      // 点击评价栏
      handleCommentClick = () => {
        navigateTo('BookCommentIndex', {
          goodsId: this.jointGoodsModel.value.goodsId,
        })
      }
    },
)
